window.reviewService = {
    async getReviews(params = {}) {
        const response = await fetch(window.appConfig.routes.getReviews, {
            method: 'post',
            headers: {
                'X-CSRF-TOKEN': window.appConfig.csrfToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params),
        });

        if (!response.ok) {
            return { status: response.status, data: [] };
        }

        return await response.json();
    },
};